import { SEQUENTIAL_MODALS, STATUS, MAX_DISPLAY_COUNT } from '../../constants/sequentialModals';
import {
  DONE_SUCCESS,
  RESET,
  SET_STATUS,
  DECREASE_MODAL_COUNT,
  SET_MODAL_COUNT_TO_ZERO,
  SET_MODAL_COUNT,
} from '../actionConstants/sequentialModals';

export const initialState = Object.freeze({
  [SEQUENTIAL_MODALS.AgreementInfo]: false,
  [SEQUENTIAL_MODALS.TutorialModal]: false,
  [SEQUENTIAL_MODALS.Advertisements]: false,
  [SEQUENTIAL_MODALS.MessageModal]: false,
  [SEQUENTIAL_MODALS.Recommend]: false,
  ready: true,
  status: STATUS.INIT,
  remainingModalCount: MAX_DISPLAY_COUNT,
  nextAvailableTime: null,
});

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case RESET: {
      const { status, nextAvailableTime } = state;
      // TS-7314
      // リセットが可能なのは、ALL_DONEのときのみ。
      // また、ALL_DONEになった直後は一定時間はリセットできない。
      // これは、ウェルカムの表示でAndroidがbackgroundになることがあるため。
      // backgroundから復帰するとinitializeが走るため、ALL_DONE直後にリセットされて
      // 再度ウェルカムが表示されことの対応。
      if (status === STATUS.ALL_DONE && nextAvailableTime <= Date.now()) {
        return { ...initialState };
      }
      return state;
    }
    case DONE_SUCCESS: {
      const { modalId, toNotReady } = payload;
      const ready = toNotReady ? false : state.ready;
      return {
        ...state,
        [modalId]: true,
        ready,
      };
    }
    case SET_STATUS: {
      const { status } = payload;
      // TS-7314
      // リセットが可能なのは、ALL_DONEのときのみ。
      // また、ALL_DONEになった直後は一定時間はリセットできない。
      const coolTime = 1 * 60 * 1000; // 1min.
      const nextAvailableTime = status === STATUS.ALL_DONE ? Date.now() + coolTime : null;
      return {
        ...state,
        status,
        nextAvailableTime,
      };
    }
    case DECREASE_MODAL_COUNT: {
      return {
        ...state,
        remainingModalCount: state.remainingModalCount - 1,
      };
    }
    case SET_MODAL_COUNT_TO_ZERO: {
      return {
        ...state,
        remainingModalCount: 0,
      };
    }
    case SET_MODAL_COUNT: {
      const { count } = payload;
      return {
        ...state,
        remainingModalCount: count,
      };
    }
    default: {
      return state;
    }
  }
};
